import All from "./All";
import { WritableStressRiskAssessmentForm } from "./WritableStressRiskAssessmentForm";
import { MyResults } from "./MyResults";
import { SraSurveyResults } from "./SraSurveyResults";

const routes = [
    { route: "/", component: All },
    { route: "/newstressriskassessment/", component: WritableStressRiskAssessmentForm },
    { route: "/myresults/", component: MyResults },
    { route: "/overview/", component: SraSurveyResults }
];

export default routes;
